<template>
  <div>
    <div class="hd mt-30">
      <img v-lazy="test.classify_image" class="fl ml-20 mr-20" />
      <p class="f22 name">{{ test.title }}</p>
      <p class="mt-20 f16 gray intro">{{ test.intro }}</p>
    </div>
    <div class="star mt-30 ml-20" style="margin-top: 36px">
      <p class="f18">您对本次测评满意吗？</p>
      <p class="mt-15 gray">
        易懂性
        <van-rate
          v-model="starArr[0]"
          allow-half
          void-icon="star"
          color="#F5A623"
          void-color="#eee"
          :readonly="seeFlag"
          class="ml-30"
        />
      </p>
      <p class="mt-15 gray">
        严谨性
        <van-rate
          v-model="starArr[1]"
          allow-half
          color="#F5A623"
          void-icon="star"
          void-color="#eee"
          :readonly="seeFlag"
          class="ml-30"
        />
      </p>
      <p class="mt-15 gray">
        其他性
        <van-rate
          v-model="starArr[2]"
          allow-half
          color="#F5A623"
          void-icon="star"
          void-color="#eee"
          :readonly="seeFlag"
          class="ml-30"
        />
      </p>
    </div>
    <div class="eval mt-20">
      <textarea
        placeholder="说说测评的心得，分享给大家～"
        v-model="note"
        :readonly="seeFlag"
      ></textarea>
      <div class="tag-group">
        <span
          v-for="(tag, index) in tags"
          :key="index"
          class="tag f12"
          @click="addToNote(tag)"
          >{{ tag }}</span
        >
      </div>
    </div>
    <van-button class="smbtn bgBlue fff" v-if="!seeFlag" @click="submit()"
      >提交评价</van-button
    >
    <van-button class="smbtn bold" v-if="seeFlag" @click="haveSubmit()"
      >已提交评价</van-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getTestDetail,
  submitTestRes,
  getCommentTags,
  getMyCommentByid,
} from "@/http/api";
export default {
  name: "comment",
  data() {
    return {
      test: {
        title: "",
        intro: "特点描述性语句",
        classify_image: require("../../../assets/img/test/testHd.png"),
      },
      starArr: [0, 0, 0],
      tags: [],
      note: "",
      seeFlag: false,
    };
  },
  computed: {
    ...mapGetters(["user", "user_id", "eval_id", "appraisal_id"]),
  },
  created() {
    if (this.$route.path.includes("comment")) {
      getTestDetail(this.appraisal_id).then((res) => {
        console.log(res);
        this.test = res.data;
      });
    }
    // console.log(this.$route.path);
    if (this.$route.path.includes("mycomment")) {
      this.seeFlag = true;
      getMyCommentByid(this.eval_id).then((res) => {
        console.log(res);
        this.starArr = [
          parseInt(res.data.dimension1),
          parseInt(res.data.dimension2),
          parseInt(res.data.dimension3),
        ];
        this.test = res.data.evaluation_dec;
        this.note = res.data.text;
      });
    } else {
      getCommentTags().then((res) => {
        this.tags = res.data.map((u) => {
          return u.tag_name;
        });
      });
    }
  },
  watch: {
    name(val) {
      this.name = val;
    },
    describe(val) {
      this.describe = val;
    },
    testImg(val) {
      this.testImg = val;
    },
  },
  // beforeRouteEnter(to, from, next) {
  //     console.log()
  //     var end = from.path.slice(from.path.lastIndexOf('/'))
  //     console.log(end)
  //     if (end !== '/result') {
  //         next(from.path.slice(0, from.path.lastIndexOf('/')))
  //     }
  //     next()
  // },
  methods: {
    submit() {
      let params = {
        appraisal: this.eval_id,
        dimension1: this.starArr[0],
        dimension2: this.starArr[1],
        dimension3: this.starArr[2],
        text: this.note,
      };
      submitTestRes(params).then((res) => {
        console.log(res);
        if (res.code === "SUCCESS") {
          this.$router.go(-1);
          // this.$router.push('./result')
        }
      });
    },
    haveSubmit() {
      this.$router.go(-1);
    },
    addToNote(tag) {
      if (this.note) {
        this.note = this.note + " " + tag;
      } else {
        this.note = tag;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.hd {
  width: 100%;
  min-height: 80px;
  img {
    width: 2.5rem;
    height: 2.4rem;
    border-radius: 0.5rem;
  }
  .name {
    position: relative;
    top: 10px;
  }
  .intro {
    line-height: 0.5rem;
  }
}
.eval {
  textarea {
    width: 80%;
    min-height: 200px;
    margin-left: 5%;
    border: 1px solid #ededed;
    border-radius: 2px;
    outline: none;
    line-height: 16px;
    padding: 5%;
  }
  .tag-group {
    width: 85%;
    margin-left: 9%;
    // margin-top: -95px;
    // position: absolute;
    // z-index: 1;
    .tag {
      display: inline-block;
      width: 21%;
      margin: 5px;
      background-color: #eceff5;
      border-radius: 5px;
      color: #9b9b9b;
      line-height: 0.8rem;
      text-align: center;
    }
  }
}
.smbtn {
  width: 90%;
  margin-left: 5%;
  margin-top: 10px;
  border-radius: 18px;
  font-size: 0.5rem;
}

.bgBlue {
  background-color: #42686e;
}
</style>